export const RecordingType = {
  GET_RECORDING_DATA: "GET_RECORDING_DATA",
  CLEAR_RECORDING_DATA: "CLEAR_RECORDING_DATA",
};
